import * as React from "react";
import styles from "./index.module.css";
import type { Shop_ShopQuery } from "@pages/shops/[uuid]/__generated__/queries";

type Props = {
  badges: Shop_ShopQuery["shop"]["statBadges"];
};

const StatBadge: React.FC<Props> = ({ badges }) => {
  return (
    <ul className={styles.statBadge}>
      {badges.map((badge) => (
        <li key={badge.displayText} className={styles.statBadgeItem}>
          {badge.displayText}
        </li>
      ))}
    </ul>
  );
};

export default StatBadge;
